module.exports = __webpack_public_path__ + "static/media/DSC_0339 (2).ba32806a.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0339 (2).JPG
// module id = 328
// module chunks = 0